import React, { createContext, useContext, useState } from 'react';
import WaitlistModal from '../components/WaitlistModal';

const WaitlistContext = createContext();

export const useWaitlist = () => {
  const context = useContext(WaitlistContext);
  if (!context) {
    throw new Error('useWaitlist must be used within WaitlistProvider');
  }
  return context;
};

export const WaitlistProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const submitEmail = async (email) => {
    // Get the backend URL — use Vercel API (Firebase Functions require Blaze plan)
    const backendUrl =
      process.env.REACT_APP_WAITLIST_API_URL ||
      'https://fiktion-lp-z6dr.vercel.app/api/waitlist';
    console.log('Submitting email to:', backendUrl);
    
    try {
      const response = await fetch(backendUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
        }),
      });

      console.log('Response status:', response.status);
      console.log('Response URL:', response.url);
      console.log('Response content-type:', response.headers.get('content-type'));
      
      // Check if response is JSON before parsing
      const contentType = response.headers.get('content-type') || '';
      if (!contentType.includes('application/json')) {
        const text = await response.text();
        console.error('Non-JSON response received. First 500 chars:', text.substring(0, 500));
        throw new Error(`API endpoint returned HTML instead of JSON. The backend may not be deployed. Status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('Response data:', data);

      if (response.ok && data.success) {
        return true;
      } else {
        throw new Error(data.error || 'Backend request failed');
      }
    } catch (error) {
      console.error('Error submitting email to backend:', error);
      console.error('Error details:', error.message);
      
      // Fallback: Store in localStorage (for development/testing)
      // In production, you should always use a backend endpoint
      try {
        const existingEmails = JSON.parse(localStorage.getItem('waitlist_emails') || '[]');
        const emailExists = existingEmails.some(e => 
          typeof e === 'string' ? e === email : e.email === email
        );
        
        if (!emailExists) {
          existingEmails.push({
            email,
            timestamp: new Date().toISOString(),
          });
          localStorage.setItem('waitlist_emails', JSON.stringify(existingEmails));
          console.log('Email stored locally (fallback):', email);
        }
        return true;
      } catch (localError) {
        console.error('Error storing locally:', localError);
        return false;
      }
    }
  };

  return (
    <WaitlistContext.Provider value={{ openModal, closeModal }}>
      {children}
      <WaitlistModal 
        isOpen={isModalOpen} 
        onClose={closeModal} 
        onSubmit={submitEmail}
      />
    </WaitlistContext.Provider>
  );
};

